import React from "react";
import { SiInstagram, SiTwitter, SiDiscord } from "react-icons/si";
import websiteNft from "../../assets/website-nft.png";
import glyph1 from "../../assets/glyph1.png";
import glyph2 from "../../assets/glyph2.png";
const Social = () => {
  return (
    <div className="section-container flex" id="social">
      <div className="w-1/2 flex items-start pl-10 max-lg:hidden">
        <img
          src={websiteNft}
          style={{ height: "80vh" }}
          alt="website-nft"
        ></img>
      </div>
      <div className="max-lg:w-full w-1/2 flex items-center justify-center">
        <img
          src={glyph1}
          alt="glyph1"
          className="h-48 z-10 opacity-60 -translate-y-36 -translate-x-10"
        ></img>
        <div className="flex flex-col items-center justify-center">
          <a href="https://instagram.com/cg_anubis_gotd?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
            <SiInstagram
              className="m-6 hover:text-egyptian-gold transition-all duration-200 ease-in-out"
              size="3rem"
            />
          </a>
          <a
            href="https://discord.com/invite/aFuMu8HSzS"
            target="_blank"
            rel="noreferrer"
          >
            <SiDiscord
              className="m-6 hover:text-egyptian-gold transition-all duration-200 ease-in-out"
              size="3rem"
            />
          </a>
          <a
            href="https://twitter.com/anubis_gotd"
            target="_blank"
            rel="noreferrer"
          >
            <SiTwitter
              className="m-6 hover:text-egyptian-gold transition-all duration-200 ease-in-out"
              size="3rem"
            />
          </a>
        </div>
        <img
          src={glyph2}
          alt="glyph2"
          className="h-48 z-10 opacity-60 translate-y-36 translate-x-10"
        ></img>
      </div>
    </div>
  );
};
export default Social;
